module.exports = __webpack_public_path__ + "static/media/mute.3157c841.png";